export class CreateTestModel {
    patientUrineTest: string=''
    IsActive: boolean
}

export class EditPatientTest{
    id: any
    patientUrineTest: string=''
    IsActive: boolean
}